module.exports = __webpack_public_path__ + "static/media/las-vegas.5962f2b8.jpg";